import { render } from "./editDaili.vue?vue&type=template&id=9cd56c22&scoped=true"
import script from "./editDaili.vue?vue&type=script&lang=js"
export * from "./editDaili.vue?vue&type=script&lang=js"

import "./editDaili.vue?vue&type=style&index=0&id=9cd56c22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd56c22"]])

export default __exports__